﻿import React from 'react'
import { WhatsappTicketsView } from '../components/whatsapp/WhatsappTicketsView'

const Whatsapp: React.FC = () => (
  <WhatsappTicketsView
    origin="bot-principal"
    moduleName="atendimentos_whatsapp"
    title="Whatsapp"
  />
)

export default Whatsapp
